

import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import { deleteYukBulItems } from "../../../features/admin5/admin5Slice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;
    .modal{
        width: 1100px;
        height: 600px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px;
            width: 1100px;
            height: 600px;
            overflow: auto;
            .titles{
                width: 100%;
                display: grid;
                grid-template-columns: 0.3fr 0.3fr 1fr;
                font-weight: var(--font-weight-lg);
                font-size: var(--font-size-sm);
                border-bottom: 2px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
                padding-bottom: 20px;
            }
            .list{
                display: flex;
                flex-direction: column;
                .info-item{
                    width: 100%;
                    display: grid;
                    grid-template-columns: 0.3fr 0.3fr 1fr;
                    font-weight: var(--font-weight-md);
                    font-size: var(--font-size-sm);
                    border-bottom: 1px solid;
                    border-color: ${({ theme }) => theme.mainBorderColor};
                    padding-block: 20px;
                    .message{
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        .title{
                            font-weight: var(--font-weight-lg);
                            font-size: var(--font-size-sm);
                            text-decoration: underline;
                        }
                    }
                }
            }
            }
        }

        .button-grp{
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            width: 640px;
            border-top: 1px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            margin-right: 8px;
        }
`

const AdminYukAriyorumModal = () => {
    
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {lookinLoadInfo} = useSelector(state => state.admin5)
    const { lockScroll, unlockScroll } = useScrollLock();


    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))} >
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                <div className="titles">
                    <p>Gönderici</p>
                    <p>Alıcı</p>
                    <p>Mesaj</p>
                </div>
                <div className="list">
                    {lookinLoadInfo?.map((item) => (
                        <div className="info-item">
                            <p>{item.senderName}</p>
                            <p>{item.receiverName}</p>
                            <div className="message">
                                <p className="title">{item.title}</p>
                                <p>{item.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
           </div>
            <div className='button-grp'>
                <Btn color="#E85446" bgColor="transparent" width={"220px"} handleClick={()=> dispatch(showModal(null))}>Kapat</Btn>
            </div>
        </div>
    </ModalContainer>
  )
}

export default AdminYukAriyorumModal